var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"text-center mt-4 mb-3",domProps:{"innerHTML":_vm._s(_vm.jsonObjectClubUnion.clubUnionHead)}}),_vm._v(" "),_c('ul',[_c('li',{domProps:{"innerHTML":_vm._s(_vm.jsonObjectClubUnion.clubs.club1.clubName)}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.jsonObjectClubUnion.clubs.club2.clubName)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fd60632","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EN-vers/menu/ClubUnion.vue
// module id = null
// module chunks = 